import { getLotteryPrizes } from 'api/client';
import { getCurrentUtcDTStr } from 'utils/dateTime';
import { getEntriesListApi } from 'api/client';
import _orderBy from 'lodash/orderBy';
export const UPDATE_MGM_REFERRAL = 'UPDATE_MGM_REFERRAL';
export const UPDATE_MGM_REFERRAL_LOTTERY_PRIZES = 'UPDATE_MGM_REFERRAL_LOTTERY_PRIZES';

const initialState = {
    userWinnerPrize: {
        winnerPrizes: [],
        thankPrizes: [],
        unOpenWinnerPrize: []
    },
    userGameResultRecords: [],
    lotteryAdmin: false,
    lotteryInstant: {},
    lotteryParticipant: {},
    lotteryTasks: {},
    lotteryPrizes: {}
};

const reducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case UPDATE_MGM_REFERRAL:
            return { ...state, ...action.payload };
        case UPDATE_MGM_REFERRAL_LOTTERY_PRIZES:
            return {
                ...state,
                ...{ lotteryPrizes: { ...state.lotteryPrizes, ...action.payload } }
            };
        default:
            return state;
    }
};

export function setMGMReferral(payload) {
    return {
        type: UPDATE_MGM_REFERRAL,
        payload
    };
}
export function setMGMReferralLotteryPrizes(payload) {
    return {
        type: UPDATE_MGM_REFERRAL_LOTTERY_PRIZES,
        payload
    };
}

export default reducer;

export function lazyGetMGMtLotteryPrizeList({ lotteryUUID }) {
    return async (dispatch, getState) => {
        const {
            mgmReferral: { lotteryPrizes } = {},
            mgmRelation: { mgmReferral: { uuid: mgmPromoUUID } } = {}
        } = getState();

        if (Array.isArray(lotteryPrizes[lotteryUUID])) {
            return lotteryPrizes[lotteryUUID];
        } else {
            const { payload: prizes } = await getLotteryPrizes(mgmPromoUUID, lotteryUUID);
            dispatch(
                setMGMReferralLotteryPrizes({
                    [lotteryUUID]: prizes
                })
            );

            return prizes;
        }
    };
}

export const entryFlowKeys = {
    SIGN_UP_FORM: 'formSignUp',
    LOTTERY_PARTICIPANT: 'lotteryParticipant'
};
export function updateFlowOfMGMEntryRecord({ entryUUID, key }) {
    return (dispatch, getState) => {
        const {
            mgmReferral: { userGameResultRecords = [] }
        } = getState();
        dispatch(
            setMGMReferral({
                userGameResultRecords: userGameResultRecords.map(r =>
                    r.uuid === entryUUID
                        ? { ...r, flow: { ...r.flow, [key]: getCurrentUtcDTStr() } }
                        : r
                )
            })
        );
    };
}

export function updateMGMGameResultRecords() {
    return async (dispatch, getState) => {
        const { mgmRelation: { mgmReferral: { uuid: mgmPromoUUID } } = {} } = getState();
        const {
            payload: { items: entries = [] }
        } = await getEntriesListApi(mgmPromoUUID);

        dispatch(
            setMGMReferral({
                userGameResultRecords: _orderBy(entries, ['id'])
            })
        );
        return entries;
    };
}
